(() => {
  const DESKTOP_QUERY = "(min-width: 990px)";
  const STYLE_ID = "atc-collection-desktop-style";

  function applyStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      ".ns-product .ns-media-wrap:hover .ns-product-atc {",
      "  display: none !important;",
      "  visibility: hidden !important;",
      "  opacity: 0 !important;",
      "  height: 0 !important;",
      "}",
    ].join("\n");
    document.head.appendChild(style);
  }

  function onHover(event, add) {
    const mediaWrap = event.target.closest(".ns-media-wrap");
    if (!mediaWrap) return;
    if (!add && mediaWrap.contains(event.relatedTarget)) return;
    const product = mediaWrap.closest(".ns-product");
    if (!product) return;
    const atcWrap = product.querySelector(".ns-atc-wrap");
    if (atcWrap) atcWrap.classList.toggle("ns-active", add);
  }

  function initDesktop() {
    const media = window.matchMedia(DESKTOP_QUERY);
    if (!media.matches) return;

    applyStyle();
    document.addEventListener("mouseover", (e) => onHover(e, true), { passive: true });
    document.addEventListener("mouseout", (e) => onHover(e, false), { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDesktop);
  } else {
    initDesktop();
  }
})();
